/**
 * Created by tdunham on 8/14/2017.
 */


export class Vendor {

	public id: number;              // ID value in the vendor_table.
	public name: string;            // The 'pretty' name of the vendor.
	public json_name: string;       // The name of the vendor when it is used in JSON as a label.
	public data_name: string;       // The name of the database field when used in RssmanagerItem.


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}


// WEBPACK FOOTER //
// ./src/app/services/vendor/vendor.ts